import { getAllEmployeesByAirport,getAllDataEmployeesByAirport } from '../../../../shared/data-services/management-employee-service';
import { getAllDataEmployeesByAirportAndCompany} from '../../../../shared/data-services/campaign-service';

// export async function getallemployeesByAirportForEdit(AirportId, CompanyId){
//   const data = await getAllEmployeesByAirportForEdit(AirportId, CompanyId);
//   return data;
// }

export async function getDataEmployeesByAirportAndCompany(AirportId, CompanyId){
  const data = await getAllDataEmployeesByAirportAndCompany(AirportId, CompanyId);
  return data;
}